import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";

interface TranslationNoticeBannerProps {
  storageKey: string;
  className?: string;
  children: React.ReactNode;
}

export function TranslationNoticeBanner({
  storageKey,
  className,
  children,
}: TranslationNoticeBannerProps) {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const wasDismissed = localStorage.getItem(storageKey) === "true";
    setDismissed(wasDismissed);
  }, [storageKey]);

  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(storageKey, "true");
    setDismissed(true);
  };

  return (
    <div
      role="alert"
      className={cn(
        "relative mx-auto mt-4 flex max-w-xl items-start gap-3 rounded-lg border border-primary/20 bg-primary/10 px-4 py-3 text-sm leading-relaxed text-foreground",
        className,
      )}
    >
      <span className="flex-1 text-left">{children}</span>
      <button
        type="button"
        onClick={handleDismiss}
        aria-label="Dismiss"
        className="shrink-0 rounded-full p-1 text-primary hover:bg-primary/10"
      >
        <X className="size-4" />
      </button>
    </div>
  );
}
